import { lazy } from 'react';
import { PageRouter } from '@tools/ui/types';
import { ShiftManagerTab } from '../enums/shiftManagerTabs.enum';

const RulerPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/ruler'
    )
);

const Manage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage'
    )
);

const PaymentsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage/statistics/payments/PaymentsPage'
    )
);

const RiskPaymentsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage/statistics/payments/RiskPaymentsPage'
    )
);

const CompliancePaymentsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage/statistics/payments/CompliancePaymentsPage'
    )
);

const BusinessesPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage/statistics/businesses'
    )
);

const OrganizationsPage = lazy(
  () =>
    import(
      /* webpackChunkName: "SherlockRoutes" */ '../pages/sherlock/shift-manager/manage/statistics/organizations'
    )
);

export const shiftManagerRoutes: PageRouter[] = [
  {
    name: 'manage',
    path: '/manage',
    exact: false,
    component: Manage,
    tabs: [
      {
        name: ShiftManagerTab.Payments,
        path: '/payments',
        component: PaymentsPage
      },
      {
        name: ShiftManagerTab.RiskPayments,
        path: '/risk-payments',
        component: RiskPaymentsPage,
        displayName: 'Risk (Payments)'
      },
      {
        name: ShiftManagerTab.CompliancePayments,
        path: '/compliance-payments',
        component: CompliancePaymentsPage,
        displayName: 'Compliance (Payments)'
      },
      {
        name: ShiftManagerTab.Organizations,
        path: '/organizations',
        component: OrganizationsPage
      },
      {
        name: ShiftManagerTab.Businesses,
        path: '/businesses',
        component: BusinessesPage
      }
    ],
    hideFromMenu: true
  },
  {
    name: 'ruler',
    path: '/ruler',
    component: RulerPage,
    tabs: [],
    hideFromMenu: true
  }
];
